import React, { Component } from "react";
import { Container, Button, ModalFooter, ModalBody } from "reactstrap";
import RequestManager from "../../singletons/RequestManager";
import config from "../../config";
import {generateHeaders, generateHeaderswithBasicAuthToken, generateEpochTimestamp, generateSignature} from "../../utils/helper";
export default class ConfirmPayatCounter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkout: null,
    };
  }
  componentDidMount() {
    this.get_checkout_details();
  }
  render() {
    return (
      <Container fluid style={{ padding: 0, margin: 0, alignItems: "center" }}>
        <ModalBody>
          <h5 style={{ margin: 10, fontWeight: "bold" }}>
            Confirmation is customer payment?
          </h5>

          <p style={{ margin: 10, fontSize: 20 }}> {"Payment details:"}</p>
          {this.state.checkout &&
            this.state.checkout.map((checkout) => {
              return (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginLeft: 10,
                    marginRight: 10,
                    justifyContent: "space-between",
                  }}
                >
                  <p>{checkout[0] + " :"}</p>
                  <p>{checkout[1]}</p>
                </div>
              );
            })}
        </ModalBody>
        <ModalFooter>
          <div>
            <Button
              color="success"
              onClick={() => {
                this.updatePayCounter();
              }}
            >
              Confirm
            </Button>{" "}
            <Button
              color="danger"
              style={{ paddingLeft: 25, paddingRight: 25 }}
              onClick={() => {
                this.props.goBack();
              }}
            >
              No
            </Button>
          </div>
        </ModalFooter>
      </Container>
    );
  }

  get_checkout_details = async () => {
    this.setState({ initialLoading: true });
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let authToken = storeInformation.token;
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Token " + authToken);
    console.log(
      "params",
      JSON.stringify({
        checkout_id: this.props.order.node.cart.checkout.id,
      })
    );
    // region_name
    try {
      var vtimestamp = generateEpochTimestamp();
      let response = await fetch(
        config.getHost() + "/product/get_checkout_details/",
        {
          method: "POST",
          headers: {
            Authorization: `Token ${authToken}`,
            "Content-Type": "application/json",
            Timestamp: vtimestamp,
            Signature: generateSignature(vtimestamp, authToken)                
          },
          body: JSON.stringify({
            checkout_id: this.props.order.node.cart.checkout.id,
          }),
        }
      );

      console.log("Response", response);

      if (response.status === 200) {
        let json = await response.json();
        let res = json.result;
        console.log("res", res);
        this.setState({ checkout: res });
      } else {
        this.setState({
          initialLoading: false,
        });
      }
    } catch (error) {
      console.log("error", error);
      this.setState({
        initialLoading: false,
      });
    }
  };

  updatePayCounter = async () => {
    let requestManager = new RequestManager();
    let params = {
      input: {
        id: this.props.order.node.cart.checkout.paymentRequests.edges[0].node
          .id,
        isCompleted: true,
      },
    };

    let response = await requestManager.getResponseFromPredefinedQuery(
      "updatePayCounter",
      params
    );
    console.log("updatePayCounter", JSON.stringify(response));
    if (response.error === null) {
      //   this.toggleErrorLoginModal("Succefully updated.");
      this.props.goBack();
    } else {
      // alert("Unable to update. Please check your internet connection.");
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/DetailedOrderCard/ConfirmPayatCounter.js